var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-flex items-center"},[_c('span',{on:{"click":function($event){return _vm.$emit('go-back')}}},[_c('i',{staticClass:"fas text-xs fa-arrow-left mr-3 cursor-pointer"})]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }